// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDocumentByIdRequestModel from '../../model/get-document-by-id-request-model';
import GetDocumentByIdRequestDTO from '../dto/get-document-by-id-request-dto';

export default abstract class GetDocumentByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDocumentByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<GetDocumentByIdRequestDTO>): GetDocumentByIdRequestModel;
  static toModel(dto: DeepPartial<GetDocumentByIdRequestDTO> | undefined | null): GetDocumentByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDocumentByIdRequestDTO> | undefined | null): GetDocumentByIdRequestModel | undefined {
    return dto ? new GetDocumentByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDocumentByIdRequestModel> | GetDocumentByIdRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
    } as GetDocumentByIdRequestDTO;
  }
}
